import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { setCookieValue } from "@/app/utils/utility";
import { useSelector } from "react-redux";

export default function CommingSoonModal({ isOpen, onOpenChange }) {
  const { items } = useSelector((state) => state.cart.cartDetails);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange} className="text-center">
      <DialogContent>
        <DialogHeader className="flex justify-center items-center">
          <DialogTitle className="text-2xl font-semibold">
            Comming Soon ...
          </DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
